import React from 'react';
import styles from './FAQPage.module.css';

export default function FAQPage() {
  const faqs = [
    {
      question: "Will this work with my existing phone number?",
      answer: "Yes. There is no need to change or replace anything. Our system listens for call events through your provider (like Telnyx) and automatically triggers the text-back workflow."
    },
    {
      question: "Does it replace my phone system?",
      answer: "No. You keep your current phone system. We simply add automation on top of it."
    },
    {
      question: "Can I customize the message?",
      answer: "Absolutely. You can fully customize:",
      list: [
        "The missed-call text",
        "AI agent tone and personality",
        "Follow-up flows",
        "Scheduling logic"
      ]
    },
    {
      question: "Do I need new hardware or special software?",
      answer: "No. Everything is cloud-based and works with what you already have."
    },
    {
      question: "Does the system integrate with my CRM?",
      answer: "Yes. We support HubSpot, Salesforce, GoHighLevel, Zoho, Airtable, and many others. We can also create custom integrations."
    },
    {
      question: "How quickly does the missed call text go out?",
      answer: "Usually within 1–3 seconds, depending on your carrier."
    },
    {
      question: "Can the AI book appointments?",
      answer: "Yes. Our AI agent can check availability, book appointments, reschedule, and send reminders."
    },
    {
      question: "Do you offer contracts?",
      answer: "No contracts. Cancel anytime."
    },
    {
      question: "Is my data secure?",
      answer: "Yes. We use encrypted communication and industry-standard security practices."
    },
    {
      question: "What types of businesses use My AI Agent?",
      answer: "Any business that relies on phone leads: Home services, real estate, automotive, beauty, dental/medical, legal, retail, and more."
    }
  ];

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>My AI Agent</h1>
      
      {faqs.map((faq, index) => (
        <div key={index} className={styles.faqItem}>
          <div className={styles.question}>{faq.question}</div>
          <div className={styles.answer}>
            {faq.answer}
            {faq.list && (
              <ul className={styles.list}>
                {faq.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
